import { gql } from '@apollo/client'

export const CANCEL_PAYMENT_MUTATION = gql`
  mutation cancelPayment($paymentId: ID!) {
    cancelPayment(paymentId: $paymentId) {
      id
      status
    }
  }
`
